import { CSSProperties, PropsWithChildren, ReactElement } from "react";
import { formatPrice } from "utils/helpers";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

enum AccessoireType {
  product,
  accessoires,
  services,
  boiler,
}

export const SolutionDetailListItem: React.FC<
  PropsWithChildren<{
    name?: string;
    previewUrl?: string;
    prix: number;
    description?: string;
    quantite?: number;
    isSelected?: boolean;
    headerButton: ReactElement;
    style?: CSSProperties;
    type?: AccessoireType;
  }>
> = ({
  name,
  prix,
  description,
  previewUrl,
  quantite,
  isSelected,
  headerButton,
  style,
  type,
  children,
}) => {
  const { t } = useTranslation();
  const { network } = useSalesNetwork();
  const backgroundColor =
    type === AccessoireType.product
      ? "main"
      : isSelected
      ? "main"
      : "accent-xtralight";

  const textColor =
    type === AccessoireType.product ? "white" : isSelected ? "white" : "";
  return (
    <group
      data-direction="column"
      data-border=""
      data-radius="5"
      data-contain=""
      style={style}
    >
      <group
        data-align="center"
        data-gap="5"
        data-background={backgroundColor}
        data-space="5"
        data-space-horizontal="20"
        data-height="40"
        data-wrap="no"
      >
        <text
          data-uppercase=""
          data-weight="600"
          data-ellipsis=""
          data-color={textColor}
          //data-wrap="wrap"
        >
          {name} {(quantite as number) > 1 && <b>({quantite})</b>}
        </text>
        {headerButton}
      </group>
      <group data-space="10" data-gap="5" data-height="autofit">
        <group
          data-ratio="1:1"
          data-shrink="no"
          data-contain=""
          data-length="120"
          data-height="120"
          data-space="10"
          data-border=""
          data-radius="5"
        >
          <picture>
            {previewUrl ? (
              <img src={previewUrl} data-object-fit="contain" alt="" />
            ) : (
              <>
                <group
                  data-height="fit"
                  data-align="center"
                  data-justify="center"
                  data-background="grey-color-light"
                  data-text-size="10"
                  data-color="grey-color-mid"
                >
                  no preview
                </group>
              </>
            )}
          </picture>
        </group>
        {(network?.showPrice || description) && (
          <group data-length="300" data-align="start" data-max-length="300">
            <group data-gap="5" data-space="5">
              {network?.showPrice && (
                <group data-name="cost" data-align="center">
                  <text data-text-size="22">
                    {formatPrice(prix)} {t("FO_SOL_CURRENCY")}
                  </text>
                </group>
              )}
              {description && (
                <group>
                  <text
                    data-wrap="wrap"
                    data-line="20"
                    data-light=""
                    data-ellipsis=""
                  >
                    {t(description)}
                  </text>
                </group>
              )}
            </group>
          </group>
        )}
      </group>
      {children}
    </group>
  );
};
